/**
 * The small page a business puts on its own web space when it cannot set a redirect there (S40):
 * `karte/index.html`, sending the guest on to the link at once, without a script; the link in the
 * text for a browser that does not follow. Nothing is kept by the phones, unlike a 301. For a PDF
 * link (`pdf` its name) the same, to its address.
 */
const esc = (s: string) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

export function redirectPage(link: string, house: string, pdf?: string): string {
  const to = esc(link);
  return `<!doctype html>
<html lang="de">
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<meta http-equiv="refresh" content="0; url=${to}">
<meta name="robots" content="noindex">
<title>${esc(pdf ?? "Speisekarte")} · ${esc(house)}</title>
</head>
<body>
<p><a href="${to}">${pdf ? `Zu „${esc(pdf)}“ (PDF)` : "Zur Speisekarte"}</a></p>
</body>
</html>
`;
}
